import React from "react";

export const GateMaterials = ({
  allMaterials,
  design,
  team,
  showSimplified,
}) => {
  if (showSimplified) return null;

  return (
    <>
      {/* Gate */}
      {(allMaterials.singleGates > 0 || allMaterials.doubleGates > 0) &&
        design.gate?.gate?.included &&
        (() => {
          const gateQty =
            (allMaterials.singleGates || 0) +
            (allMaterials.doubleGates || 0) * 2;

          return (
            <div className="border-b border-gray-300 p-3 md:grid md:grid-cols-5 md:items-center hover:bg-gray-50">
              {/* Mobile: Stacked layout */}
              <div className="md:hidden mb-2">
                <p className="font-bold text-lg">Gate</p>
                <p className="text-gray-600">{design.gate.gate.name}</p>
                <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
                  <div>
                    <span className="text-gray-500">Quantity:</span>
                    <span className="ml-1 font-semibold">{gateQty}</span>
                  </div>
                  {team.tierLimits.seePrices && (
                    <div>
                      <span className="text-gray-500">Price:</span>
                      <span className="ml-1 font-semibold">
                        ${design.gate.gate.price}
                      </span>
                    </div>
                  )}
                  <div>
                    <span className="text-gray-500">Total:</span>
                    <span className="ml-1 font-bold text-blue-600">
                      ${(gateQty * design.gate.gate.price).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Desktop: Grid layout */}
              <p className="hidden md:block font-medium">Gate</p>
              <p className="hidden md:block text-gray-700">
                {design.gate.gate.name}
              </p>
              <p className="hidden md:block">{gateQty}</p>
              {team.tierLimits.seePrices && (
                <p className="hidden md:block">${design.gate.gate.price}</p>
              )}
              <p className="hidden md:block font-semibold text-blue-600">
                ${(gateQty * design.gate.gate.price).toFixed(2)}
              </p>
            </div>
          );
        })()}

      {/* Single Gate Kit */}
      {allMaterials.singleGates > 0 && design.gate?.singleGateKit?.included && (
        <div className="border-b border-gray-300 p-3 md:grid md:grid-cols-5 md:items-center hover:bg-gray-50">
          <div className="md:hidden mb-2">
            <p className="font-bold text-lg">Single Gate Kit</p>
            <p className="text-gray-600">{design.gate.singleGateKit.name}</p>
            <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
              <div>
                <span className="text-gray-500">Quantity:</span>
                <span className="ml-1 font-semibold">
                  {allMaterials.singleGates}
                </span>
              </div>
              {team.tierLimits.seePrices && (
                <div>
                  <span className="text-gray-500">Price:</span>
                  <span className="ml-1 font-semibold">
                    ${design.gate.singleGateKit.price}
                  </span>
                </div>
              )}
              <div>
                <span className="text-gray-500">Total:</span>
                <span className="ml-1 font-bold text-blue-600">
                  $
                  {(
                    allMaterials.singleGates * design.gate.singleGateKit.price
                  ).toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          <p className="hidden md:block font-medium">Single Gate Kit</p>
          <p className="hidden md:block text-gray-700">
            {design.gate.singleGateKit.name}
          </p>
          <p className="hidden md:block">{allMaterials.singleGates}</p>
          {team.tierLimits.seePrices && (
            <p className="hidden md:block">
              ${design.gate.singleGateKit.price}
            </p>
          )}
          <p className="hidden md:block font-semibold text-blue-600">
            $
            {(
              allMaterials.singleGates * design.gate.singleGateKit.price
            ).toFixed(2)}
          </p>
        </div>
      )}

      {/* Double Gate Kit */}
      {allMaterials.doubleGates > 0 && design.gate?.doubleGateKit?.included && (
        <div className="border-b border-gray-300 p-3 md:grid md:grid-cols-5 md:items-center hover:bg-gray-50">
          <div className="md:hidden mb-2">
            <p className="font-bold text-lg">Double Gate Kit</p>
            <p className="text-gray-600">{design.gate.doubleGateKit.name}</p>
            <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
              <div>
                <span className="text-gray-500">Quantity:</span>
                <span className="ml-1 font-semibold">
                  {allMaterials.doubleGates}
                </span>
              </div>
              {team.tierLimits.seePrices && (
                <div>
                  <span className="text-gray-500">Price:</span>
                  <span className="ml-1 font-semibold">
                    ${design.gate.doubleGateKit.price}
                  </span>
                </div>
              )}
              <div>
                <span className="text-gray-500">Total:</span>
                <span className="ml-1 font-bold text-blue-600">
                  $
                  {(
                    allMaterials.doubleGates * design.gate.doubleGateKit.price
                  ).toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          <p className="hidden md:block font-medium">Double Gate Kit</p>
          <p className="hidden md:block text-gray-700">
            {design.gate.doubleGateKit.name}
          </p>
          <p className="hidden md:block">{allMaterials.doubleGates}</p>
          {team.tierLimits.seePrices && (
            <p className="hidden md:block">
              ${design.gate.doubleGateKit.price}
            </p>
          )}
          <p className="hidden md:block font-semibold text-blue-600">
            $
            {(
              allMaterials.doubleGates * design.gate.doubleGateKit.price
            ).toFixed(2)}
          </p>
        </div>
      )}

      {/* Gate Extension */}
      {allMaterials.gateExtensions > 0 &&
        design.gate?.gateExtension?.included && (
          <div className="border-b border-gray-300 p-3 md:grid md:grid-cols-5 md:items-center hover:bg-gray-50">
            <div className="md:hidden mb-2">
              <p className="font-bold text-lg">Gate Extension</p>
              <p className="text-gray-600">{design.gate.gateExtension.name}</p>
              <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
                <div>
                  <span className="text-gray-500">Quantity:</span>
                  <span className="ml-1 font-semibold">
                    {allMaterials.gateExtensions}
                  </span>
                </div>
                {team.tierLimits.seePrices && (
                  <div>
                    <span className="text-gray-500">Price:</span>
                    <span className="ml-1 font-semibold">
                      ${design.gate.gateExtension.price}
                    </span>
                  </div>
                )}
                <div>
                  <span className="text-gray-500">Total:</span>
                  <span className="ml-1 font-bold text-blue-600">
                    $
                    {(
                      allMaterials.gateExtensions *
                      design.gate.gateExtension.price
                    ).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>

            <p className="hidden md:block font-medium">Gate Extension</p>
            <p className="hidden md:block text-gray-700">
              {design.gate.gateExtension.name}
            </p>
            <p className="hidden md:block">{allMaterials.gateExtensions}</p>
            {team.tierLimits.seePrices && (
              <p className="hidden md:block">
                ${design.gate.gateExtension.price}
              </p>
            )}
            <p className="hidden md:block font-semibold text-blue-600">
              $
              {(
                allMaterials.gateExtensions * design.gate.gateExtension.price
              ).toFixed(2)}
            </p>
          </div>
        )}
    </>
  );
};
